<body>
    <div class="main-wrapper">
        <div class="main-content">
            <header>

                <div class="head-line">

                    <p>Company</p>


                </div>
                <div class="user-wrapper">
                    <p>{{storedData.agencyRefId.agencyName}}</p>

                    <div>
                        <img class="log1"
                            [src]="this.storedData.agencyRefId.logo?this.storedData.agencyRefId.logo:'../../../../assets/../../assets/images/user1.jpeg'">
                    </div>
                </div>
            </header>


            <div class="header2">

                <a *ngFor="let caseType of  this.selectedCases; let i = index" class="btn"
                    [ngClass]="{ 'active': selectedCase === caseType.name }" (click)="selectCase(caseType.name)">
                    {{ caseType.name }} <span>{{ caseType.count }}</span>
                </a>

            </div>

            <div class="header3">

               
                <div class="checkbox-container" style="margin-right: 10px;
                    display: flex;
                    align-items: center;
                    margin-bottom: -7px;">
                    <input type="checkbox" id="selectAll" [(ngModel)]="isChecked" (change)="onCheckboxChange()" 
                     style="margin-bottom: 10px;"/>
                    <label for="selectAll">Freezone</label>
                </div>


              

                <div class="dropdown-container" style="flex-wrap: nowrap;"> 
                    <label for="rows">Rows</label>
                    <div class="middle-b"></div>
                    <select id="rows" (change)="onTableSizeChange($event)">
                        <option value="25">25</option>
                        <option value="50">50</option>
                        <option value="100">100</option>
                        <option value="150">150</option>
                        <option value="1000">1000</option>

                    </select>
                </div>





                <!-- <div class="dropdown-container" style="    width: 196px;">
                    <label for="rows">Initiated By</label>
                    <div class="middle-b"></div>
                    <select id="rows"  (change)="onInitiatedByChange($event)" >
                        <option *ngFor="let item of staffDetails" [value]="item._id">{{item.name}}</option>
                        
                    </select>
                </div> -->




                <div class="fill-sea">
                    <div class="search-m">
                        <input type="text" id="searchQueryInput2" placeholder="Search here..." [(ngModel)]="searchQuery"
                             (ngModelChange)="onSearchChange($event)">
                        <button type="submit" id="searchQuerySubmit"><svg viewBox="0 0 24 24"
                                style="width: 24px; height: 24px;">
                                <path fill="#666666"
                                    d="M9.5,3A6.5,6.5 0 0,1 16,9.5C16,11.11 15.41,12.59 14.44,13.73L14.71,14H15.5L20.5,19L19,20.5L14,15.5V14.71L13.73,14.44C12.59,15.41 11.11,16 9.5,16A6.5,6.5 0 0,1 3,9.5A6.5,6.5 0 0,1 9.5,3M9.5,5C7,5 5,7 5,9.5C5,12 7,14 9.5,14C12,14 14,12 14,9.5C14,7 12,5 9.5,5Z">
                                </path>
                            </svg>
                        </button>
                    </div>
                    <!-- <div class="filter-img-container">
                        <img src="../../assets/images/filter_alt.png" class="filter-img">
    
                    </div> -->
                </div>
                <a *ngIf="this.storedData.userType[0].userType=='Client Admin'" class="btn"
                    (click)="AllocationFlag=true"><img src="../../assets/images/autorenew.png"> Auto allocate </a>
                <a *ngIf="this.storedData.userType[0].userType=='Client Admin'" class="active btn">

                    <img src="../../assets/images/vscode-icons_file-type-excel.png">Bulk Upload
                    <img src="../../assets/images/Up-load.png">
                    <input type="file" class="file-input" (change)="ExcelUpload($event)" id="fileInputchoose"
                        accept=".xlsx, .xls">

                </a>
                <a *ngIf="this.storedData.userType[0].userType=='Client Admin'" class=" btn"
                    (click)="DownloadTemplate()">

                    Download Template

                </a>

                 <a class=" btn"
                    (click)="resetFilter()">

                    Reset Filter

                </a>



            </div>
            <!-- <ng-multiselect-dropdown class="dropdown-one" [settings]="dropdownSettings" [data]="cases"  [ngModelOptions]="{standalone: true}" [(ngModel)]="selectedStatuses"  >
           </ng-multiselect-dropdown> -->
            <!-- <label >vhvhvh</label> -->
            <!-- <ng-multiselect-dropdown class="dropdown-two" [settings]="productSettings" [data]="storedData.products"  [ngModelOptions]="{standalone: true}" [(ngModel)]="selectedProducts"   (onDropDownClose)="ListCases()" >
            </ng-multiselect-dropdown>   -->

            <div class="headertest1">

                 <ng-multiselect-dropdown class="dropdown-three" [settings]="dropdownSettingsBuisness"
                    [data]="buisnessNatures" [(ngModel)]="selectedBuisnessNatures" [ngModelOptions]="{ standalone: true }"
                    (onSelect)="onSelectField()" (onDeSelect)="onDeSelectField($event)"
                    (onSelectAll)="onselctAllB($event)"
                    (onDeSelectAll)="onDeselctAllB($event)"
                    >
                </ng-multiselect-dropdown>
                
                <ng-multiselect-dropdown class="dropdown-three" [settings]="productSettings"
                    [data]="storedData.products" [(ngModel)]="selectedProducts" [ngModelOptions]="{ standalone: true }"
                    (onSelect)="ListCases1()" (onDeSelect)="ListCases1()"
                     (onSelectAll)="onSelectAllProducts($event)"
                    (onDeSelectAll)="onDeSelectAllProducts()">
                </ng-multiselect-dropdown>

                <ng-multiselect-dropdown class="dropdown-three" [settings]="dropdownSettingsSingle" [data]="cases"
                    [(ngModel)]="selectedStatuses" [ngModelOptions]="{ standalone: true }"
                    (onSelect)="PushStatus($event)" (onDeSelect)="PushStatus($event)"
                     (onSelectAll)="onSelectAllStatuses($event)"
                    (onDeSelectAll)="onDeSelectAllStatuses()">
                </ng-multiselect-dropdown>

                <ng-multiselect-dropdown class="dropdown-three" [settings]="dropdownSettingslocation"
                    [data]="Alllocations" [(ngModel)]="selectedlocations" [ngModelOptions]="{ standalone: true }"
                    (onSelect)="Pushlocation($event)" (onDeSelect)="Pushlocation($event)"
                    (onSelectAll)="onSelectAllLocations($event)"
                    (onDeSelectAll)="onDeSelectAllLocations()">
                </ng-multiselect-dropdown>
            </div>


            <main class="main-2">

                <div class="container">
                    <div class="projects">


                        <div class="two-screen">

                            <div class="mainside2">
                                <table class="table-main">
                                    <thead>


                                        <tr>

                                            <th style="cursor: pointer;width:2%" (click)="sortTable('createdAt')">
                                                Initiated date <span *ngIf="sortField === 'createdAt'">
                                                    {{ sortOrder === 'asc' ? '▲' : '▼' }}
                                                </span></th>
                                            <th style="cursor: pointer;width:13%"
                                                (click)="sortTable('initiatedBy.name')">Initiated by<span
                                                    *ngIf="sortField === 'initiatedBy.name'">
                                                    {{ sortOrder === 'asc' ? '▲' : '▼' }}
                                                </span></th>
                                            <th style="cursor: pointer;width:25%" (click)="sortTable('clientName')">
                                                Company name<span *ngIf="sortField === 'clientName'">
                                                    {{ sortOrder === 'asc' ? '▲' : '▼' }}
                                                </span></th>
                                            <th style="cursor: pointer;width:8%" (click)="sortTable('updatedAt')">
                                                Updated date<span *ngIf="sortField === 'updatedAt'">
                                                    {{ sortOrder === 'asc' ? '▲' : '▼' }}
                                                </span></th>

                                            <th style="cursor: pointer;width:8%" (click)="sortTable('updatedBy')">
                                                Updated by<span *ngIf="sortField === 'updatedBy'">
                                                    {{ sortOrder === 'asc' ? '▲' : '▼' }}
                                                </span></th>


                                            <th (click)="sortTable('currentAllocation')"
                                                style="cursor: pointer;width:7%">Current Allocation <span
                                                    *ngIf="sortField === 'clientRefId'">
                                                    {{ sortOrder === 'asc' ? '▲' : '▼' }}
                                                </span></th>

                                            <th style="cursor: pointer;width:15%" (click)="sortTable('products')">
                                                Products<span *ngIf="sortField === 'updatedAt'">
                                                    {{ sortOrder === 'asc' ? '▲' : '▼' }}
                                                </span></th>


                                            <th style="cursor: pointer;width:15%" (click)="sortTable('location')">
                                                location<span *ngIf="sortField === 'location'">
                                                    {{ sortOrder === 'asc' ? '▲' : '▼' }}
                                                </span></th>
                                            <th class="med-width" style="cursor: pointer;width:10%"
                                                (click)="sortTable('status')">Status<span
                                                    *ngIf="sortField === 'status'">
                                                    {{ sortOrder === 'asc' ? '▲' : '▼' }}
                                                </span></th>
                                            <th class="right-align" style="width:8%">Actions </th>
                                            <!-- <th class="right-align move-right"><img src="img/Ellipse 92.svg"></th> -->
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <tr *ngFor="let eachCase of this.showingCases | paginate : pagingConfig; let i = index;  "
                                            (dblclick)="ClientDetail('EDIT',eachCase); $event.stopPropagation()">

                                            <td style="width:8%">
                                                <p class="name-one" (click)="copyText(format(eachCase.createdAt))" title="Click to copy">{{ format(eachCase.createdAt)}}</p>
                                            </td>

                                            <td style="width:10%">
                                                <p class="name-one" (click)="copyText(eachCase.initiatedBy?.name)" title="Click to copy">{{eachCase.initiatedBy?.name}}</p>
                                            </td>
                                            <td style="width:25%">
                                                <p class="name-one" (click)="copyText(eachCase.clientName)" title="Click to copy">{{eachCase.clientName}} </p>
                                            </td>
                                            <td style="width:8%">
                                                <p class="name-one" (click)="copyText(format(eachCase.updatedAt))" title="Click to copy">{{ format(eachCase.updatedAt)}}</p>
                                            </td>
                                            <td style="width:8%">
                                                <p class="name-one" (click)="copyText(eachCase.updatedBy.name)" title="Click to copy">{{eachCase.updatedBy?eachCase.updatedBy.name:''}}
                                                </p>
                                            </td>
                                            <td style="width:6%">
                                                <p class="name-one" (click)="copyText(eachCase.currentAllocation)" title="Click to copy">{{eachCase.currentAllocation}}</p>

                                            </td>
                                            <td style="width:10%" style="width:10%; display: flex; flex-wrap: wrap;">
                                                <ng-container *ngIf="isArray(eachCase.products)">
                                                    <button class="status-one" *ngFor="let each of eachCase.products" (click)="copyText(each.name)" title="Click to copy">
                                                        {{ each.name }}
                                                    </button>
                                                </ng-container>

                                                <ng-container *ngIf="!isArray(eachCase.products) && eachCase.products">
                                                    <button class="status-one" (click)="copyText(eachCase.products.name)" title="Click to copy">
                                                        {{ eachCase.products.name }}
                                                    </button>
                                                </ng-container>
                                            </td>


                                            <td style="width:6%">
                                                <p class="name-one" (click)="copyText(eachCase.location)" title="Click to copy">{{eachCase.location}}</p>

                                            </td>

                                            <td style="width:10%"><button class="status-one" (click)="copyText(eachCase.status)"
                                                    [ngClass]="getStatusClass(eachCase.status)" title="Click to copy">{{eachCase.status}}
                                                   
                                                    <!-- <img
                                                        src="../../assets/images/green-circle.png"> -->
                                                </button> <span *ngIf="eachCase.subStatus" class="sub-status">({{ eachCase.subStatus }})</span></td>
                                            <td class="right-align" style="width:8%">
                                                <div class="pop-over" style="cursor: pointer;">
                                                    <img src="../../assets/images/eye-open (1).png"
                                                        style="filter: invert(1) brightness(0);"
                                                        (click)="ClientDetail('EDIT',eachCase)">&nbsp;&nbsp;&nbsp;&nbsp;
                                                    <img src="../../assets/images/Delete.png"
                                                        *ngIf="!(this.storedData.userType[0].userType!=='Client Admin' && tab=='All Cases')"
                                                        style="filter: invert(16%) sepia(99%) saturate(7493%) hue-rotate(356deg) brightness(95%) contrast(108%);"
                                                        (click)="disable(eachCase)">

                                                </div>
                                            </td>
                                        </tr>







                                    </tbody>

                                </table>
                                <pagination-controls previousLabel="Prev" nextLabel="Next"
                                    (pageChange)="onTableDataChange($event)">
                                </pagination-controls>
                                <span style="    margin-left: 76px;">{{currentCount }} Of {{ total}}</span>

                            </div>

                            <!--float button-->
                            <a (click)="ClientDetail('ADD',{})" class="float6"
                                *ngIf="storedData.userType[0].userType === 'Client Admin' || storedData.userType[0].userType === 'Backend Staff'">
                                <img src="../../assets/images/plus.png"> Add New Company
                            </a>

                            <!-- </div> -->



                        </div>

                    </div>

                </div>


            </main>

        </div>
    </div>

    <div class="footer-section2">

        <img src="../../assets/images/accruon-footer (2).png">
    </div>

</body>


<div id="" class="overlay" *ngIf="AllocationFlag">
    <div class="popup-ins" id="popup-ins1">
        <div class="ins-f" id="ins-f1">
            <h2>Auto allocate</h2>

            <form class="staff-form mt-2">

                <div class="row">
                    <div class="col-lg-12 col-xs-12 col-sm-6">
                        <div class="form-group">
                            <select id="rows" [(ngModel)]="autoType" [ngModelOptions]="{standalone:true}"
                                (change)="this.selectedItems=[]">
                                <!-- <option disabled></option> -->
                                <option value="telle">Tele Callers</option>
                                <option value="backend">Back End Staffs</option>

                            </select>

                        </div>

                        <div class="form-group">
                            <label>Count </label>

                            <input type="number" [(ngModel)]="count" class="form-control"
                                [ngModelOptions]="{standalone:true}">

                        </div>
                    </div>
                </div>


                <div class="form-group">
                    <label>Product </label>

                    <!-- <input type="number" [(ngModel)]="count"  class="form-control" [ngModelOptions]="{standalone:true}"> -->

                    <select id="rows" [ngModelOptions]="{standalone:true}" [(ngModel)]="product">
                        <option *ngFor="let row of selectedProducts" [value]="row._id">{{row.name}}</option>
                    </select>


                </div>
                <br>

                <div class="form-group d-flex align-items-center gap-2">
                    <label class="me-2">From</label>
                    <input type="date" [(ngModel)]="from" class="form-control" [ngModelOptions]="{standalone:true}">

                    <label class="ms-3 me-2">To</label>
                    <input type="date" [(ngModel)]="to" class="form-control" [ngModelOptions]="{standalone:true}">
                </div>

                <br>



                <div class="row">
                    <div class="col-lg-12 col-xs-12 col-sm-6">
                        <div class="form-group">
                            <label>Please Select Staffs For Auto Allocation </label>
                            <ng-multiselect-dropdown *ngIf="autoType=='backend'" [settings]="dropdownSettings"
                                [data]="PuncedStaffs" [ngModelOptions]="{standalone: true}" [(ngModel)]="selectedItems">
                            </ng-multiselect-dropdown>


                            <ng-multiselect-dropdown *ngIf="autoType=='telle'" [settings]="dropdownSettings"
                                [data]="PuncedTeleCallerStaffs" [ngModelOptions]="{standalone: true}"
                                [(ngModel)]="selectedItems">
                            </ng-multiselect-dropdown>



                        </div>
                    </div>
                </div>
            </form>
        </div>

        <div class="ins-footer">
            <button class="btn-sec" (click)="AllocationFlag=false">Back</button>
            <button class="btn-prime" (click)="allocate()">Allocate</button>
        </div>

    </div>
</div>

<ngx-spinner
  bdColor="rgba(0,0,0,0.4)"
  size="medium"
  color="#fff"
  type="ball-scale-multiple">

  <p style="color:white">Loading...</p>

</ngx-spinner>